import { LocaleHelper } from '@adp-wfn/mdf-core';
import { cloneDeep } from 'lodash';
import originalMeta from '../components/data/static.json';

export const getStateList = (countryCode: string, isSelectBox?: boolean, unrestricted?: boolean) => {
  const data = [];
  const meta = cloneDeep(originalMeta);

  if (countryCode) {
    const countryJson = meta.countries[countryCode.toUpperCase()] ? meta.countries[countryCode.toUpperCase()] : meta.countries['DEFAULT'];

    if (countryJson && countryJson.fields) {
      const stateField = countryJson.fields.find((fieldObj) => fieldObj.id === 'state');

      if (stateField && stateField.list) {
        const stateList = unrestricted && stateField.restrictedList ? [...stateField.list, ...stateField.restrictedList] : stateField.list;
        const locale: any = LocaleHelper.getUserLocale().split('-')[0];
        const count: number = stateList.length;

        for (let i = 0; i < count; i++) {
          const option = stateList[i];
          let labelObj = option.labels.find((myObj) => myObj.locale === locale);

          if (!labelObj) {
            labelObj = option.labels[0];
          }

          // Push different data object for DropdownList and MDFSelectbox
          if (isSelectBox) {
            data.push({
              value: option.value,
              label: labelObj.value
            });
          }
          else {
            data.push({
              id: option.value,
              name: labelObj.value
            });
          }
        }

        if (stateField.restrictedList) {
          // Sort the state list alphabetically by label to maintain order after merging restrictedStates
          data.sort((a, b) => {
            const nameA = isSelectBox ? a.label : a.name;
            const nameB = isSelectBox ? b.label : b.name;
            return nameA.localeCompare(nameB);
          });
        }
      }
    }
  }

  return data;
};
